import React from 'react';
import { DividerSizeTokens, ImageSizeTokens, ResizeModeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, } from '@voltmoney/schema';
import Card from '../card/Card';
import Image from '../image/Image';
import { UserCard } from '../userCard/UserCard';
import { Typography } from '../typography/Typography';
import { Stack } from '../stack/Stack';
import { Divider } from '../divider/Divider';
import { Space } from '../space/Space';
const FeedCard = ({ padding = {
    horizontal: SizeTypeTokens.NONE,
    bottom: SizeTypeTokens.MD,
}, margin = {
    top: SizeTypeTokens.XL,
}, user, imageURL, title, onPress, triggerAction, leftWidgets = [], rightWidgets, action, renderItem, }) => {
    // if (!title) return <></>;
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Card, { onPress: handleAction, padding: padding, margin: margin, header: {
            children: (React.createElement(UserCard, { padding: {
                    horizontal: SizeTypeTokens.XL,
                }, ...user })),
        }, body: {
            children: [
                React.createElement(Card, { padding: {
                        top: SizeTypeTokens.LG,
                        bottom: SizeTypeTokens.MD,
                        horizontal: SizeTypeTokens.XL,
                    }, body: {
                        children: React.createElement(Typography, { label: title }),
                    } }),
                imageURL ? (React.createElement(Image, { uri: imageURL, size: ImageSizeTokens.FULL, resizeMode: ResizeModeToken.CONTAIN })) : (React.createElement(React.Fragment, null)),
                React.createElement(Space, { size: imageURL
                        ? SizeTypeTokens.MD
                        : SizeTypeTokens.NONE }),
            ],
        }, footer: {
            children: leftWidgets?.length > 0 || rightWidgets ? ([
                React.createElement(Card, { padding: {
                        vertical: SizeTypeTokens.MD,
                        horizontal: SizeTypeTokens.XL,
                    }, body: {
                        children: (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                            React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.flexStart }, renderItem &&
                                leftWidgets.length > 0 &&
                                leftWidgets.map((widget) => renderItem({ ...widget }))),
                            renderItem &&
                                rightWidgets &&
                                renderItem(rightWidgets))),
                    } }),
                leftWidgets?.length > 0 || rightWidgets ? (React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.MD } })) : (React.createElement(React.Fragment, null)),
            ]) : (React.createElement(React.Fragment, null)),
        } }));
};
export default React.memo(FeedCard, (prevProps, nextProps) => {
    return prevProps === nextProps;
});
export { FeedCard };
